/**
 * @fileoverview String utility functions for formatting and manipulation.
 */

/**
 * Formats a number as currency using the Intl.NumberFormat API.
 *
 * @param {number} value The numeric value to format as currency.
 * @param {Intl.NumberFormatOptions} [options] Formatting options for the currency.
 * @param {string} [options.currency="USD"] The currency code to use.
 * @returns {string} The formatted currency string.
 */
export const formatCurrency = (
  value: number,
  options: Intl.NumberFormatOptions = {
    currency: "USD",
  },
): string => {
  const formatter = Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    currency: options.currency,
    style: "currency",
  });

  return formatter.format(value);
};
